export default "__VITE_ASSET__VpTMAZA3__"